import React from 'react';

import { getEntityFields } from '@lucid/utils';

import SEO from '../seo/seo';
import type { Template, CustomDrupal } from '../../types/types';

type LucidHeadProps = {
  data: CustomDrupal.DrupalData;
  // TODO: see if we can tighten up this Partial type
  pageContext: Template.Context & Partial<Template.ContextPaginationData>;
  location?: Partial<Location>;
};

const LucidHead = <T,>({ data, pageContext, location }: LucidHeadProps) => {
  // Keeping this functionality in LucidHead for now, in the event that we decide to re-add a conditional scripts component
  const { drupal } = data;
  const { page, pageType, metatags: pageMetatags } = pageContext;
  const node = drupal?.nodeById as unknown as T;
  const { entityMetatags, entitySchemaMetatags } = getEntityFields(node || {});
  const titleMetatag =
    (entityMetatags as Template.Metatag[]).find(({ key }) => key === 'title') ||
    pageMetatags?.find(({ key }) => key === 'title');

  const paginationEntityMetatags =
    page && page > 1
      ? [
          {
            key: 'title',
            value: `Page ${page} for ${titleMetatag?.value}`,
            id: titleMetatag?.key,
          },
          {
            key: 'robots',
            value: 'follow, noindex',
            id: `${pageType}-robots-meta-script`,
          },
        ]
      : undefined;
  const metatags = paginationEntityMetatags ?? (entityMetatags.length ? entityMetatags : pageMetatags);

  return <SEO entityMetatags={metatags} entitySchemaMetatags={entitySchemaMetatags} location={location} />;
};

export default LucidHead;
